export default "__VITE_ASSET__f0467337__"